import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const location = useLocation();

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-8 right-8 z-40 w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-all duration-300 cursor-pointer opacity-80 hover:opacity-100"
      aria-label="回到顶部"
      title="回到顶部"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}